import { render, staticRenderFns } from "./index-prospectos.vue?vue&type=template&id=24df5ea6"
import script from "./index-prospectos.vue?vue&type=script&lang=js"
export * from "./index-prospectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports